import { Component } from '@theme/component';

class TabsComponent extends Component {
  #buttons = [];
  #panels = [];

  static ACTIVE_CLASS = 'is-active';

  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#unbind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#init();
  }

  #init() {
    this.#unbind();

    const nav = this.querySelector('[ref="nav"]');
    const panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

    if (!nav || panels.length === 0) return;

    this.#buttons = Array.from(nav.querySelectorAll('[data-tab-button]'));
    this.#panels = panels;

    for (const [index, button] of this.#buttons.entries()) {
      const title = this.#panels[index]?.getAttribute('data-tab-title');

      if (title) button.textContent = title;

      button.addEventListener('click', this.#handleTabClick);
    }

    this.#activateTab(0);
  }

  #unbind() {
    for (const button of this.#buttons) {
      button.removeEventListener('click', this.#handleTabClick);
    }

    this.#buttons = [];
    this.#panels = [];
  }

  #handleTabClick = (event) => {
    const index = this.#buttons.indexOf(event.currentTarget);

    if (index === -1) return;

    this.#activateTab(index);
  };

  #activateTab(index) {
    for (const [i, button] of this.#buttons.entries()) {
      const isActive = i === index;
      button.setAttribute('aria-selected', String(isActive));
      button.classList.toggle(TabsComponent.ACTIVE_CLASS, isActive);
    }

    for (const [i, panel] of this.#panels.entries()) {
      const isActive = i === index;

      if (isActive) {
        panel.hidden = false;
        requestAnimationFrame(() => {
          if (!panel.hidden) panel.classList.add(TabsComponent.ACTIVE_CLASS);
        });
      } else {
        panel.classList.remove(TabsComponent.ACTIVE_CLASS);
        panel.hidden = true;
      }
    }
  }
}

if (!customElements.get('tabs-component')) {
  customElements.define('tabs-component', TabsComponent);
}
